export interface IAuthDwhData {
    action: EAuthDwhAction;
    source?: string;
}

export enum EAuthDwhAction {
    licenseOpen = 'license-open',
    licenseAccept = 'license-accept',
    licenseReject = 'license-reject',
}
